import React, {useEffect} from 'react';
import './assets/sass/app.scss';
import {AppRouter} from './AppRouter';
import './lib/i18n/config';
import {EventType, Application} from '../src/constants';
import {loadTrusteScript} from './lib/truste/truste';
import {postAnalytics} from './lib/analytics/postAnalytics';
import {useAppSelector} from './store';
import {
  isAnalyticsEnabled,
  isHashRoutingEnabled,
  logAppVersion,
} from './util/config';
import {isCustomBrandedRealm} from './urlUtils';
import LandingContainer from './pages/landing-page/LandingContainer';

const App = () => {
  const isAnalytics = isAnalyticsEnabled();
  const isHashRouting = isHashRoutingEnabled();

  // Log the deployed application version
  logAppVersion();

  useEffect(() => {
    if (isAnalytics) {
      loadTrusteScript();
      postAnalytics(Application.load, EventType.PageViewEvent);
    }
  }, [isAnalytics]);

  const isBrandingApplied = useAppSelector(
    (state) => state.isBrandingApplied.value,
  );
  if (isCustomBrandedRealm(window.location.hostname) && !isBrandingApplied) {
    return <LandingContainer />;
  }
  return <AppRouter isHashRouting={isHashRouting} />;
};

export default App;
